/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "App";
import { reportWebVitals } from "reportWebVitals";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "theme";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "./index.css";
import "i18n";
import { BrowserRouter } from "react-router-dom";
import { Auth0ProviderWithRedirectCallback } from "components/Auth0/Auth0ProviderWithRedirectCallback";

const root = createRoot(document.getElementById("root") as HTMLElement);

// NOTE: StrictMode disabled because bugs from googlemaps api.
// https://github.com/JustFly1984/react-google-maps-api/issues/3064
root.render(
  <>
    <StrictMode></StrictMode>
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <Auth0ProviderWithRedirectCallback
            domain={`${process.env.REACT_APP_AUTH0_DOMAIN}`}
            clientId={`${process.env.REACT_APP_AUTH0_CLIENT_ID}`}
            useRefreshTokens={true}
            authorizationParams={{
              redirect_uri: window.location.origin,
              audience: `${process.env.REACT_APP_AUTH0_AUDIENCE}`,
              scope:
                "profile email offline_access read:current_user update:current_user_metadata",
            }}
          >
            <App />
          </Auth0ProviderWithRedirectCallback>
        </BrowserRouter>
      </ThemeProvider>
    </>
    <StrictMode></StrictMode>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
